module.exports = __webpack_public_path__ + "static/media/LadyBoneDemonTowerEXTA0076_design_clean_v001.64eeea8f.png";